






































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BSpinner } from "bootstrap-vue";
import { BPopover } from "bootstrap-vue";

@Component({
  components: {
    BSpinner,
    BPopover,
  },
  computed: mapState("auth", ["user"]),
})
export default class Header extends Vue {
  @Prop(String) readonly title!: string;
  async logout() {
    this.$router.push("login");
    this.$store.dispatch("auth/logout");
  }
}
